module.exports = __webpack_public_path__ + "img/20b1dae.jpg";